<template>
  <div />
</template>

<script>
import store from '@/store/index';
import i18n from '@/locales/i18n';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.params.eventId || !to.params.companyId || !to.params.memberSourceId || !to.params.activityId) {
      // 前往活動錯誤頁函數
      next({
        name: 'Error',
        params: { content: i18n.t('error.url-invalid') },
      });
    } else {
      // 取得活動資料
      store.dispatch('getActivity').then((activity) => {
        if (!activity || activity.status !== 'submitted') {
          // 前往活動錯誤頁函數
          next({
            name: 'Error',
            params: { content: i18n.t('error.activity-not-found') },
          });
        } else {
          // 導頁到活動頁
          next({
            name: activity.isShareFullURL ? 'FrontPage' : 'FrontPageFake',
            params: to.params,
          });
        }
      });
    }
  },
};
</script>
